import { inject, Injectable } from "@angular/core";
import { EffectsBase } from "clicklease-ui-elements";
import { RoseService } from "../../services";
import { LoadCustomersAction, LoadCustomersFailureAction, LoadCustomersSuccessAction } from "./customers.actions";
import { ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";

@Injectable()
export class CustomersDataEffects extends EffectsBase {
    readonly #roseService = inject(RoseService);

    public readonly loadCustomers = this.createEffect(() =>
        this.actions.pipe(
            ofType(LoadCustomersAction),
            mergeMap(({ filterText }) => this.getCustomers(filterText))
    ));

    private getCustomers(filterText: string) {
        return this.#roseService.getCustomers(filterText).pipe(
            map(response => LoadCustomersSuccessAction({ customers: response.roses })),
            catchError(error => of(LoadCustomersFailureAction({ error })))
        );
    }
}
